import { Dialog } from 'primereact/dialog';
import styles from './ConfigurePeriodModal.module.scss';
import AnimatedLoadingIcon from '../../../../common/Icons/AnimatedLoadingIcon';
import ValueSelector from '../ValueSelector/ValueSelector';

export default function ConfigurePeriodModal({
  open,
  handleOpen,
  bonusTypes,
  setBonusTypes,
  isSavingBonusTypes,
  handleSaveBonusTypes
}) {

  return (
    <div className={styles.container}>
      <Dialog
        visible={open}
        onHide={() => handleOpen(false)}
        className="text-modal-dialog"
        style={{ width: '500px' }}
        header="Configurer la periode de calcule pour chaque type de prime"
        footer={
          <div className={styles.footer}>
            <button
              size="small"
              severity="success"
              className={styles.save_btn}
              onClick={handleSaveBonusTypes}
              disabled={isSavingBonusTypes}
            >
              {
                isSavingBonusTypes ? (
                  <AnimatedLoadingIcon color="#ffffff" />
                ):
                'Enregistrer'
              }
            </button>
          </div>
        }
      >
        <div className={styles.items}>
          {bonusTypes.map(item => (
            <div key={item.id} className={styles.item}>
              <p className={styles.item_label}>
                {item.label}
              </p>
              <ValueSelector
                values={[
                  { label: "Annual", checked: item.isAnnual },
                  { label: "Trimestriel", checked: item.isQuarterly },
                ]}
                onCheckValueChange={(label, checkStatus) => {
                  let field = label === "Annual" ? 'isAnnual' : "isQuarterly";
                  const newState = bonusTypes.map(it => it.id !== item.id ? it : { ...it, [field]: checkStatus })
                  setBonusTypes(newState);
                }}
              />
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
}
